import React from "react";

export default function UserCardPulse({ user }) {
  return (
    <div className="rounded animate-pulse">
      <div className="flex items-center">
        <div className={`"w-12 h-12 bg-gray-200 rounded-full mr-4"`}></div>
        <div className="text-xs w-40">
          <div className="text-gray-900 font-bold bg-gray-200 h-5"></div>
          <div className="text-green-800 bg-gray-200 h-5"></div>
        </div>
      </div>
    </div>
  );
}
